// eslint-disable-next-line import/prefer-default-export
export const testAttributes = {
    ICON_ELEMENT: 'icon_default_element',
};
